export const WEBHOOKS = {
  publish_all: process.env.REACT_APP_MAKE_WEBHOOK_PUBLISH_ALL,      // Publicar en todas
  update_wc_ml: process.env.REACT_APP_MAKE_WEBHOOK_UPDATE_WC_ML,    // Actualizar WC + ML
  inactivate_wc_ml: process.env.REACT_APP_MAKE_WEBHOOK_INACTIVATE_WC_ML, // Inactivar en WC + ML
};